module.exports = __webpack_public_path__ + "media/images/team/MarianaSaraiva-8dcda7ae485c740184944926d7d2bfe9.png";